import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { Home, Admin, Cart, NoMatch, OffSiteProducts, TransactionComplete } from "./components";
import { CartContextProvider, DealerContextProvider, useDealer } from "./contexts";
import MainLayout from "./components/layouts/MainLayout";
import Login from "./components/pages/Login";
import Channels from "./components/pages/Channels";
import Checkout from "./components/pages/Checkout";
import SessionSaved from "./components/pages/SessionSaved";
import Android from "./components/pages/Android";
import { theme } from "./theme";
import "./App.css";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { dealer } = useDealer();

  if (!dealer) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <DealerContextProvider>
        <CartContextProvider>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <MainLayout>
                  <Home />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/login" element={
              <MainLayout>
                <Login />
              </MainLayout>
            } />
            <Route path="/login/channels" element={
              <ProtectedRoute>
                <MainLayout>
                  <Channels />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/cart" element={
              <ProtectedRoute>
                <MainLayout>
                  <Cart />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/offsite" element={
              <ProtectedRoute>
                <MainLayout>
                  <OffSiteProducts />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/checkout" element={
              <ProtectedRoute>
                <MainLayout>
                  <Checkout />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/transaction-complete" element={
              <ProtectedRoute>
                <MainLayout>
                  <TransactionComplete />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/session-saved" element={
              <ProtectedRoute>
                <MainLayout>
                  <SessionSaved />
                </MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/android" element={<Android />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </CartContextProvider>
      </DealerContextProvider>
    </ThemeProvider>
  );
}

export default App;
